import {IActionModel} from "../../shared/models/action.model";
import {SET_CURRENT_NAV_PARAMS, SET_SIDE_MENU_VIEW} from "../actions/header.action";

export interface IHeaderReducerState {
    sideMenuView: "compact" | "default" | "collapsed";
    currentNavParams: {
        title: string,
        meta?: string,
        backNavigationRoute: any
    };
    prevNavParams?: {
        title: string,
        meta?: string,
        backNavigationRoute: any
    };
    clearCurrentNav: any;
}

const INITIAL_STATE: any = {
    sideMenuView: "default",
    currentNavParams: {
        title: "",
        meta: ""
    },
    clearCurrentNav: {}
};

const headerReducer = (state: IHeaderReducerState = INITIAL_STATE, action: IActionModel): IHeaderReducerState => {
    switch (action.type) {
        case SET_CURRENT_NAV_PARAMS:
            return {
                ...state,
                prevNavParams: {
                    title: state.currentNavParams.title,
                    meta: state.currentNavParams.meta,
                    backNavigationRoute: state.currentNavParams.backNavigationRoute,
                },
                currentNavParams: {
                    title: action.payload.title,
                    meta: action.payload.meta,
                    backNavigationRoute: action.payload.backNavigationRoute,
                }
            };
        case SET_SIDE_MENU_VIEW:
            return {
                ...state,
                sideMenuView: action.payload.sideMenuView
            }
        default:
            return state;
    }
};

export default headerReducer;
